module.exports = __webpack_public_path__ + "static/img/performance06.0b1c6da4.jpg";